import { pdfjs } from 'react-pdf';
// Resolve the pdf.js worker through Vite's module graph (`?url`) so it is
// emitted as a content-hashed asset under /assets and served with a correct
// JS MIME type. Importing this module for its side effect sets the global
// worker source once for every react-pdf consumer.
//
// This replaces a hardcoded `/assets/pdfjs-dist/build/pdf.worker.min.js` path
// that was populated by vite-plugin-static-copy. Under Vite 8 / Rolldown the
// copy plugin emitted the worker to a deeply-nested wrong path (preserving the
// full node_modules source tree and ignoring `rename`), so the hardcoded URL
// 404'd and pdf.js failed with "Setting up fake worker failed".
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
